module.exports = __webpack_public_path__ + "static/media/collective_events.9c79e9cb.jpg";